module.exports = __webpack_public_path__ + "static/media/banner.e86b1de8.png";